import { Pipe, PipeTransform } from '@angular/core';

import { PackagingFormat } from '@mtna/rds-packaging-ui';

/**
 * Gets the count of selected formats
 * @author Will Davis <will.davis@mtna.us>
 */
@Pipe({
  name: 'rdsFormatSelectedCount'
})
export class RdsFormatSelectedCountPipe implements PipeTransform {
  transform(selected: Array<PackagingFormat>, format: PackagingFormat): number {
    if (!selected || !selected.length || !format) {
      return 0;
    }
    return selected.filter(f => f.id === format.id).length;
  }
}
